<template>
    <section>
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

        <b-field horizontal label="Название">
            <b-input name="subject" expanded disabled v-model="name"></b-input>
        </b-field>

        <b-field horizontal label="Описание">
            <b-input type="textarea" expanded v-model="description"></b-input>
        </b-field>

        <b-field horizontal label="Цена">
            <b-input name="subject" expanded disabled v-model="price"></b-input>
        </b-field>

        <div class="block">
            <b-field horizontal label="Изображение">
                <b-upload v-model="uploadImage" drag-drop>
                    <section>
                        <div class="content has-text-centered">
                            <img style="width: 400px; height: 100%" :src="uploadImage ? uploadedImage:  image" :alt="name">
                        </div>
                    </section>
                </b-upload>
            </b-field>
        </div>

        <b-field horizontal>
            <p class="control">
                <b-button label="Сохранить" type="is-primary" @click="edit()" :disabled="loading"/>
            </p>
        </b-field>
    </section>
</template>

<script>
import comboRepository from "../../repository/comboRepository";

export default {
    props: {
        id: {
            required: true,
            type: [String, Number]
        }
    },
    computed: {
        uploadedImage() {
            if (!this.uploadImage)
                return;

            return URL.createObjectURL(this.uploadImage);
        }
    },
    data() {
        return {
            name: null,
            price: null,
            description: null,
            image: null,
            uploadImage: null,
            loading: false
        }
    },
    methods: {
        fetchData() {
            this.loading = true;

            comboRepository.get(this.id)
                .then(({data}) => {
                    this.name = data.name
                    this.description = data.description
                    this.image = data.image
                    this.price = data.price
                })
                .finally(() => {
                    this.loading = false
                })
        },
        edit() {
            this.loading = true;

            comboRepository.edit(this.id, this.description, this.uploadImage)
                .then(() => this.$router.push({name: "Combo"}))
                .then(() => this.$buefy.toast.open('Комбо обновлено'))
                .catch(() => this.$buefy.toast.open('Ошибка при обновлении акции'))
                .finally(() => {
                    this.loading = false
                })
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>

<style scoped>

</style>
